import React from 'react'

import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { AnalyticsPostCampaignReportGlossaryEntry } from '@components/Analytics/PostCampaignReport/Glossary'
import { CPM_EXPLAINED } from '@constants'
import { PCRChannels } from '@enums'
import { IApplicationState } from '@store'
import { selectCampaignOperatingRegionTaxName } from '@store/campaigns'
import { selectPostsTotalSpend } from '@store/postCampaignReport'
import { selectCampaignId } from '@store/router'
import Theme from '@theme'
import { Link } from '@tribegroup'

const AnalyticsPostCampaignReportGlossaryPost: React.FC = () => {
  const match = useRouteMatch()
  const intl = useIntl()
  const campaignId = selectCampaignId(match)!

  const totalSpendCurrency = useSelector(
    (state: IApplicationState) =>
      selectPostsTotalSpend(state, campaignId, PCRChannels.IGPosts).currency,
  )
  const taxName = useSelector((state: IApplicationState) =>
    selectCampaignOperatingRegionTaxName(state, campaignId, intl, totalSpendCurrency),
  )

  return (
    <React.Fragment>
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="post.published" />
      <AnalyticsPostCampaignReportGlossaryEntry
        translationKey="post.spend"
        values={{
          taxDisplay: taxName,
        }}
      />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="post.followers" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="post.likes" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="post.comments" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="post.engagement" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="post.engagementPercentage" />
      <AnalyticsPostCampaignReportGlossaryEntry
        translationKey="post.cpe"
        values={{
          taxDisplay: taxName,
        }}
      />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="post.reach" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="post.reachPercentage" />
      <AnalyticsPostCampaignReportGlossaryEntry translationKey="post.impressions" />
      <AnalyticsPostCampaignReportGlossaryEntry
        translationKey="post.cpm"
        values={{
          link: (
            <Link href={CPM_EXPLAINED} target="_blank" color={Theme.primaryColor} lowercase>
              <FormattedMessage id="core.text.clickHere" />
            </Link>
          ),
        }}
      />
    </React.Fragment>
  )
}

export default AnalyticsPostCampaignReportGlossaryPost
